export default "__VITE_ASSET__cvhhg8xk__"